<div *ngIf="!vm.loading && vm.isSiffiUser">
            <loader-overlay *ngIf="vm.loading"></loader-overlay>
            <div *ngIf="vm.bannerVisible && vm.assignedTraining" class="training-banner" [ngClass]="{'bg-siffi': vm.origin === 'siffi.com', 'bg-minudoc': vm.origin === 'minudoc.ee'}" >
                <div class="training-icon-wrap">
                    <svg viewBox="0 0 24 24">
                        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"></path>
                    </svg>
                </div>

                <div class="training-banner-content">
                    <div class="training-banner-top">
                        <div class="training-banner-label">{{ 'Training.Assigned.Title' | translate }}</div>
                        <div class="training-banner-carousel" *ngIf="vm.assignedPrograms?.length > 1">
                            <button class="training-carousel-btn" (click)="vm.previousBannerProgram($event)" [attr.aria-label]="'Training.My_Training.Previous_Program' | translate">&larr;</button>
                            <span class="training-carousel-count">{{ (vm.bannerIndex || 0) + 1 }}/{{ vm.assignedPrograms.length }}</span>
                            <button class="training-carousel-btn" (click)="vm.nextBannerProgram($event)" [attr.aria-label]="'Training.My_Training.Next_Program' | translate">&rarr;</button>
                        </div>
                    </div>
                    <div class="training-banner-title">{{ vm.program?.title }}</div>
                    <div class="training-banner-sub">
                        {{  vm.getTrainingEnrollmentMessage()}}
                    </div>
					<div class="training-banner-sub" *ngIf="vm.assignedToolkit" style="margin-top:6px;">
						<a href="javascript:void(0)" (click)="vm.openMyToolkit($event)" style="color:inherit;text-decoration:underline;">
							{{ 'Toolkit.Menu.My_Toolkit' | translate }} ({{ vm.assignedToolkitCount }})
						</a>
					</div>
                    <div class="training-banner-dots" *ngIf="vm.assignedPrograms?.length > 1">
                        <button
                            class="training-banner-dot"
                            *ngFor="let program of vm.assignedPrograms; let i = index"
                            [class.training-banner-dot--active]="i === vm.bannerIndex"
                            (click)="vm.selectBannerProgram(i, $event)"
                            [attr.aria-label]="vm.getProgramAriaLabel(i)">
                        </button>
                    </div>
                </div>

                <div class="training-banner-right">
                    <div class="training-progress-ring">
                        <svg width="80" height="80" viewBox="0 0 80 80">
                            <circle class="bg" cx="40" cy="40" r="34" fill="none" stroke-width="7"></circle>
                            <circle class="fg"
                                    cx="40"
                                    cy="40"
                                    r="34"
                                    fill="none"
                                    stroke-width="7"
                                    [attr.stroke-dasharray]="vm.circumference"
                                    [attr.stroke-dashoffset]="vm.progressOffset">
                            </circle>
                        </svg>
                        <div class="training-progress-text">{{ vm.completedModules || 0 }}/{{ vm.totalModules || 0 }}</div>
                    </div>

                    <button class="training-btn" (click)="vm.onPrimaryAction()">
                        {{ vm.primaryActionLabel() }} &rarr;
                    </button>
                </div>
            </div>


			<div *ngIf="!vm.assignedTraining && vm.assignedToolkit" class="training-banner" [ngClass]="{'bg-siffi': vm.origin === 'siffi.com', 'bg-minudoc': vm.origin === 'minudoc.ee'}">
				<div class="training-icon-wrap">
					<svg viewBox="0 0 24 24">
						<path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"></path>
					</svg>
				</div>
				<div class="training-banner-content">
					<div class="training-banner-top">
						<div class="training-banner-label">{{ 'Toolkit.Provider.Client.AssignedToolkits' | translate }}</div>
					</div>
					<div class="training-banner-title">
						{{ vm.latestAssignedToolkitTitle || ('Toolkit.Assigned.Banner.Title' | translate) }}
					</div>
					<div class="training-banner-sub">
						{{ vm.latestAssignedToolkitSub || ('Toolkit.Assigned.Banner.Subtitle' | translate) }}
					</div>
				</div>
				<div class="training-banner-right">
					<button class="training-btn" (click)="vm.openMyToolkit($event)">
						{{ 'Toolkit.Common.Open' | translate }} &rarr;
					</button>
				</div>
			</div>
</div>
